import React, { Component } from 'react';

export class Notification extends Component {

  constructor(props) {
    super(props);
      this.state = {};
    }

    componentDidMount() {
        this.getCSOData();
    }

    async getCSOData() {
        const response = await fetch('csostationdata');
        await response.json().then((data) => {

            var map = new window.google.maps.Map(document.getElementById('map'), {
                zoom: 12,
                center: new window.google.maps.LatLng(41.60, -81.470),
                mapTypeId: window.google.maps.MapTypeId.ROADMAP
            });

            var infowindow = new window.google.maps.InfoWindow();

            var marker, i, name, latitude, longitude;
            //var normalIcon = "http://maps.google.com/mapfiles/ms/icons/blue-dot.png";
            //var warningIcon = "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png";
            //var alarmIcon = "http://maps.google.com/mapfiles/ms/icons/red-dot.png";
            //var noDataIcon = "http://maps.google.com/mapfiles/ms/icons/green-dot.png";

            var normalIcon = "green.png";
            var warningIcon = "yellow.png";
            var alarmIcon = "red.png";
            var noDataIcon = "white.png";

            var image = normalIcon;
            var lastEventStartDate = null;
            var lastEventEndDate = null;
            var dataDate = null;

            var lastEventStartDate_Formated = null;
            var lastEventEndDate_Formated = null;
            var dataDate_Formated = null;

            var hours;
            var days;

            var dischargeLocation = "";
            var receivingWater = "";
            var publicAccessArea = "";
            var lastEventTotalVolume = "";

            for (i = 0; i < data.length; i++) {

                latitude            = data[i].latitude;
                longitude           = data[i].longitude;
                lastEventStartDate  = data[i].lastEventStartDate;
                lastEventEndDate    = data[i].lastEventEndDate;
                dataDate            = data[i].dataDate;
                dischargeLocation   = data[i].dischargeLocation;
                receivingWater      = data[i].receivingWater;
                publicAccessArea    = data[i].publicAccessArea;
                lastEventTotalVolume = data[i].lastEventTotalVolume;
                lastEventTotalVolume = !lastEventTotalVolume ? "N/A" : (Number(lastEventTotalVolume) / 1000000).toFixed(6);

                lastEventStartDate_Formated = this.formatDate(new Date(lastEventStartDate));
                lastEventEndDate_Formated   = this.formatDate(new Date(lastEventEndDate));
                dataDate_Formated           = this.formatDate(new Date(dataDate));

                image = normalIcon;
                let detailsCommon = "<div><h3>" + data[i].siteNameFull + "</h3></div>" +
                    "<div><strong>" + data[i].siteAddress + "</strong></div>" +
                    "<div><strong>" + data[i].siteName + "</strong></div><br/>";
                //default
                let details = detailsCommon +
                    "<div>Status: <strong>No overflow in the past 48 hours</strong></div><br/>" +
                    "<div>Last updated: <strong>" + dataDate_Formated + "</strong></div><br/>";

                hours = this.hoursSince(dataDate);

               if (hours >= 12) {
                        image = noDataIcon;
                        details = detailsCommon +
                            "<div>Status: <strong>No data in the past 12 hours</strong></div><br/>";
                        if (dataDate === '0001-01-01T00:00:00') {
                            details += "<div>Last updated: <strong>N/A</strong></div><br/>";
                        } else
                            details += "<div>Last updated: <strong>" + dataDate_Formated + "</strong></div><br/>";
                    }

                else if (lastEventStartDate !== '0001-01-01T00:00:00' && lastEventEndDate === '0001-01-01T00:00:00') {
                    image = alarmIcon;
                    details = detailsCommon +
                        "<div>Status: <strong>Overflow is active</strong></div><br/>" +
                        "<div>Event start date: <strong>" + lastEventStartDate_Formated + "</strong></div><br/>" +
                        "<div>Discharge Location: <strong>" + dischargeLocation + "</strong></div><br/>" +
                        "<div>Receiving Water: <strong>" + receivingWater + "</strong></div><br/>" +
                        "<div>Public Access areas affected: <strong>" + publicAccessArea + "</strong></div><br/>" +
                        "<div>Last updated: <strong>" + dataDate_Formated + "</strong></div><br/>";

                } else if (lastEventStartDate !== '0001-01-01T00:00:00' && lastEventEndDate !== '0001-01-01T00:00:00') {

                   hours = this.hoursSince(lastEventEndDate);
                   days = this.daysSince(lastEventEndDate);
                   if (hours <= 48) {
                       image = warningIcon;
                       //only show the details on the next day AFTER the actual details minute to minute data is downloaded at 4am 
                       //detailed data is ONLY calculated ONCE at midnight daily.
                       //i.e. on the same day, don't show volume, show volume on the next day
                       if (days >= 1) {
                           details = detailsCommon +
                               "<div>Status: <strong>Event in the past 48 hours</strong></div><br/>" +
                               "<div>Last event start date: <strong>" + lastEventStartDate_Formated + "</strong></div><br/>" +
                               "<div>Last event end date: <strong>" + lastEventEndDate_Formated + "</strong></div><br/>" +
                               "<div>Last Event Total Volume(million gallons): <strong>" + lastEventTotalVolume + "</strong></div><br/>" +
                               "<div>Discharge Location: <strong>" + dischargeLocation + "</strong></div><br/>" +
                               "<div>Receiving Water: <strong>" + receivingWater + "</strong></div><br/>" +
                               "<div>Public Access areas affected: <strong>" + publicAccessArea + "</strong></div><br/>" +
                               "<div>Last updated: <strong>" + dataDate_Formated + "</strong></div><br/>";
                       } else {
                           //don't show the actual volume if it's on the day day BEFORE the actual minute to minute data is downloaded
                           details = detailsCommon +
                               "<div>Status: <strong>Event in the past 48 hours</strong></div><br/>" +
                               "<div>Last event start date: <strong>" + lastEventStartDate_Formated + "</strong></div><br/>" +
                               "<div><strong>Total volume is calculated within 24 hours following the event and will be displayed here</strong></div><br/>" +
                               "<div>Discharge Location: <strong>" + dischargeLocation + "</strong></div><br/>" +
                               "<div>Receiving Water: <strong>" + receivingWater + "</strong></div><br/>" +
                               "<div>Public Access areas affected: <strong>" + publicAccessArea + "</strong></div><br/>" +
                               "<div>Last updated: <strong>" + dataDate_Formated + "</strong></div><br/>";
                       }
                    }
                }

                name = data[i].siteName;

                marker = new window.google.maps.Marker({
                    //position: new window.google.maps.LatLng(stations[i][1], stations[i][2]),
                    position: new window.google.maps.LatLng(latitude, longitude),
                    map: map,
                    icon: image,
                    title: name
                });
                window.google.maps.event.addListener(marker, 'click', (function (marker, i) {
                    return function () {
                        infowindow.setContent(details);
                        infowindow.open(map, marker);
                    }
                })(marker, i));
            }

            var legend = document.getElementById('legend');
            var div = document.createElement('div');
            div.innerHTML = "<strong>Legend</strong>" +
                "<table>" +
                "<tr><td><img src='red-small.png'/></td><td>CSO event in progress</td></tr>" +
                "<tr><td><img src='yellow-small.png'/></td><td>CSO event in the past 48 hours</td></tr>" +
                "<tr><td><img src='green-small.png'/></td><td>No overflow in the past 48 hours</td></tr>" +
                "<tr><td><img src='white-small.png'/></td><td>Unknown<br/>(Incomplete meter data<br/>for the past 12 hours)</td></tr>" +
                "</table>";

            legend.appendChild(div);
            map.controls[window.google.maps.ControlPosition.RIGHT_BOTTOM].push(legend);
        })
    }

    formatDate(date) {
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ampm;
        return date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear() + "  " + strTime;
    }

    hoursSince(lastDate) {
        var today = new Date();
        var endDate = new Date(lastDate);
        var diff = (today.getTime() - endDate.getTime()) / 1000;
        diff /= (60 * 60);
        var hours = Math.abs(Math.round(diff));

        return hours;
    }

    daysSince(date) {

        var today = new Date();
        var theDate = new Date(date);

        //remove time to find out actual day difference. not based on the hours difference. e.g. 11pm at previous day and 1 am next day gives 1 day difference.
        var day1 = new Date(today.toDateString());
        var day2 = new Date(theDate.toDateString());

        var Difference_In_Time = day1.getTime() - day2.getTime();
        var Difference_In_Days = Math.ceil(Difference_In_Time / (1000 * 3600 * 24));
        
        console.log(day1);
        console.log(day2);
        console.log("difference: " + Difference_In_Days);
        
        return Difference_In_Days;
        //return 1
    }

    render() {
        return (
            <div>
                <div id='map' style={{ height: "100vh" }}></div>
                <div id='legend'></div>
            </div>
    );
  }
}
